
<modal :state="state" :index="index" @toggle-modal="cancel" :should-cancel-on-outside-click="false">
  <div slot="body" class="email-modal">
    <h3 class="modal-title">Send notification</h3>

    <flash-attribute-messages v-if="shouldValidate && !isComplete"
                              messages="You must complete each field before you can continue."></flash-attribute-messages>

    <div class="form-style">

      <row>
        <column class="row-title" size="100">
          <label for="to-field" class="v-label required">Send To:<required-indicator/></label>
        </column>
        <column>
          <multi-input
            :full="notification.hasEmailDeliveryMethod">
            <column>
              <a-select
                id="to-field"
                :options="toOptions"
                :selected-option-ids="recipientIds"
                @input="createToRecipient"
                @destroy="destroyAssignee"
                bind-by-object
                multiselect>
              </a-select>
            </column>
            <suffix v-if="notification.hasEmailDeliveryMethod">
              <button
                class="btn dropdown-toggle btn-cc arrow"
                :class="{collapsed: !InstanceHelper.isPresent(ccRecipients)}"
                type="button"
                data-toggle="collapse"
                data-target="#cc"
                :aria-expanded="InstanceHelper.isPresent(ccRecipients)" aria-controls="cc">
                CC
              </button>
            </suffix>
          </multi-input>

          <div class="recipients">
            <scroll-area class="recipients">
              <ul class="tag-listing">
                <li v-for="recipient in recipients">
                  <pill :color="recipient.tagColor" @onRemove="removeAssignee(recipient)" :value="recipient.display"> 
                    <template #suffix v-if="recipient.isLegacyConfig">
                      <button type="button" class="btn-icon" v-tooltip="recipient.legacyConfigTooltip">
                        <icon class="exclamation"></icon>
                        <span class="sr-only">{{ recipient.legacyConfigTooltip }}</span>
                      </button>
                    </template>
                  </pill>
                </li>
              </ul>
            </scroll-area>
          </div>
        </column>
      </row>

      <row class="collapse" v-if="notification.hasEmailDeliveryMethod"
           :class="{show: InstanceHelper.isPresent(ccRecipients)}" id="cc">
        <column class="row-title" size="100">
          <label for="cc-field" class="v-label">CC:</label>
        </column>
        <column>
          <a-select id="cc-field"
                    :options="ccOptions"
                    :selected-option-ids="ccIds"
                    @input="createCC"
                    @destroy="destroyAssignee"
                    bind-by-object
                    multiselect></a-select>
          <div class="recipients">
            <ul class="tag-listing">
              <li v-for="recipient in ccRecipients">
                <pill :color="recipient.tagColor" @onRemove="removeAssignee(recipient)" :value="recipient.display">
                  <template #suffix v-if="recipient.isLegacyConfig">
                    <button type="button" class="btn-icon" v-tooltip="recipient.legacyConfigTooltip">
                      <icon class="exclamation"></icon>
                      <span class="sr-only">{{ recipient.legacyConfigTooltip }}</span>
                    </button>
                  </template>
                </pill>
              </li>
            </ul>
          </div>
        </column>
      </row>

      <row>
        <column class="row-title" size="100">
          <label for="subject-field" class="v-label required">Subject:<required-indicator/></label>
        </column>
        <column>
          <input type="text" v-model="notification.subject" placeholder="Enter a subject line" id="subject-field">
        </column>
      </row>
        <row>
          <column class="row-title" size="100">
            <label for="email-style" class="v-label">Style:</label>
          </column>
          <column>
            <a-select
              ref="emailStyle"
              id="email-style"
              :options="emailStyleOptions"
              v-model="notification.email_style"></a-select>
          </column>
        </row>
      <fieldset v-if="notification.show_delivery_methods">
        <row>
          <column class="row-title" size="100">
            <crayon tag="legend" color="Inherit">Format:</crayon>
          </column>
          <column>
            <div class="radio-inline">
              <input type="checkbox"
                     :id="`notification_via_in_system_${notification.client_id}`"
                     :name="`notification_via_in_system_${notification.client_id}`"
                     v-model="deliveryMethods"
                     :value="NotificationDeliveryMethod.ViaInSystem">
              <label :for="`notification_via_in_system_${notification.client_id}`">In-System</label>
            </div>
            <div class="radio-inline">
              <input type="checkbox"
                     :id="`notification_via_email_${notification.client_id}`"
                     :name="`notification_via_email_${notification.client_id}`"
                     v-model="deliveryMethods"
                     :value="NotificationDeliveryMethod.ViaEmail">
              <label :for="`notification_via_email_${notification.client_id}`">Email</label>
            </div>
          </column>
        </row>
      </fieldset>

      <row>
        <column class="row-title" size="100">
          <label for="body-field" class="required">Body:<required-indicator/></label>
        </column>
        <column>
          <wysiwyg
            id="body-field"
            name="body-field"
            :set-tag="false"
            v-model="notification.body"
            placeholder="Type your message here"
            :config-options="wysiwygConfigOptions"
            :dynamic-options="dynamicWysiwygOptions"
            v-on:mounted="updateDynamicReferencesTexts"
          ></wysiwyg>
        </column>
      </row>

      <row>
        <column class="row-title" size="100">
          <label :for="notification.idForProp('linked_detail_view_id')" class="v-label">Detail View Link:</label>
        </column>
        <column>
          <a-select :id="notification.idForProp('linked_detail_view_id')"
                    v-model="notification.linked_detail_view_id"
                    :options="linkedDetailViewOptions"
                    ></a-select>
        </column>
      </row>
    </div>

    <br>

    <div class="cta">
      <button @click="cancel" class="btn block red outline">Cancel</button>
      <button @click="save" class="btn block green">Save</button>
    </div>
  </div>
</modal>
